import { render, staticRenderFns } from "./BuilderRow.vue?vue&type=template&id=5bb8ac82&"
import script from "./BuilderRow.vue?vue&type=script&lang=js&"
export * from "./BuilderRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports